// src/apiConfig.js

const API_BASE_URL = "https://nine9cents-backend.onrender.com";

export default API_BASE_URL;
